import React, { useState, useEffect } from 'react';
import Remove from '../../assets/remove.png';
import Change from '../../assets/change.png';
import PerfectScrollbar from 'react-perfect-scrollbar';

const Compteur = () => {
  const [nom, setNom] = useState('');
  const [unité, setUnité] = useState('');
  const [secteurActivite, setSecteurActivite] = useState('');
  const [etat, setEtat] = useState('');
  const [compteur, setCompteur] = useState([]);

  const updateEtat = (id) => {
    setEtat((prev) => ({ ...prev, [id]: 'En Marche' }));
  };

  const registerCompteur = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch('https://fusionsmart.seifeddineslimene.com/api/compteur', {
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({
          nom,
          unité,
          secteurActivite,
        }),
      });
      const data = await response.json();
      const { lastAddedCompteur } = data;
      setCompteur([...compteur, lastAddedCompteur]);
      setNom('');
      setUnité('');
      setSecteurActivite('');
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetch('https://fusionsmart.seifeddineslimene.com/api/compteur', {
      method: 'GET', // Spécifie la méthode GET
      headers: {},
    })
      .then((response) => {
        return response.json(); // return response.json() first
      })
      .then((json) => {
        setCompteur(json); // then set the json into the items
      })
      .catch((error) => console.error('Error fetching compteur:', error));
  }, []);

  const deleteCompteur = (id) => {
    fetch(`https://fusionsmart.seifeddineslimene.com/api/compteur/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Error deleting compteur');
        }
        return response.json();
      })
      .then(() => {
        setCompteur(compteur.filter((compteur) => compteur._id !== id));
        alert('compteur deleted successfully');
      })
      .catch((error) => {
        console.error('Error deleteClick', error);
      });
  };

  return (
    <div
    id='content-body'
    className='d-flex flex-column align-items-center col-12 col-md-9 col-xl-10 pl-4 pr-4 bd-content overflow-auto'
  >
       <div className='mb-8' style={{ height: '60px' }}>
        <div className='col-md-12 pt-4'>
            <h2>Meter Management

            </h2>
            </div>
      </div>
      <div
        className='text-center mt-5'
        style={{
          height: 'calc(100vh - 150px - 60px)',
          boxSizing: 'border-box',
          overflow: 'auto',
        }}
      >
          <PerfectScrollbar>
        <form
          onSubmit={registerCompteur}
          className='user ms-2 mb-5 row'
            style={{ width: '90%' }}
        >
            <div className='col-6 d-flex justify-content-center align-items-center mb-4'>
            
          <span className='d-inline-block me-2'>Nom</span>
            <input
              value={nom}
              onChange={(e) => setNom(e.target.value)}
              placeholder=' Name'
              type='text'
              className='w-75 px-4 py-4 border rounded-lg'            />
          </div>

          <div className='col-6 d-flex justify-content-center align-items-center mb-4'>
          <span className='d-inline-block me-2'>unité</span>
            <input
              value={unité}
              onChange={(e) => setUnité(e.target.value)}
              placeholder='unité'
              type='text'
              className='w-75 px-4 py-4 border rounded-lg'
              />
          </div>
          <div className='col-6 d-flex justify-content-center align-items-center mb-4'>
          <span className='d-inline-block me-2'>secteurActivite</span>
            <input
              value={secteurActivite}
              onChange={(e) => setSecteurActivite(e.target.value)}
              placeholder='secteurActivite'
              type='text'
              className='w-75 px-4 py-4 border rounded-lg'
              />
          </div>
          <div className='col-12'>
            <button
              type='submit'
              className='bg-primary text-white py-2 px-4 rounded border border-0 fw-bold ms-5  mb-4'
              >
              Envoyer
            </button>
          </div>
          <table className='table'>
            <thead>
            <tr className='bg-black text-white text-left'>
                <th className='px-4 py-6 font-bold'>nom </th>
                <th className='px-4 py-6 font-bold'>unité</th>
                <th className='px-4 py-6 font-bold'>secteurActivite</th>
                <th className='px-4 py-6 font-bold'>etat</th>
                <th className='px-4 py-6 font-bold'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {compteur &&
                compteur.map((val) => (
                  <tr key={val._id}>
                    <td>{val.nom}</td>
                    <td>{val.unité}</td>
                    <td>{val.secteurActivite}</td>
                    <td
                      className={`shadow-sm px-4 py-6 ${
                        etat[val._id] === 'Complete'
                          ? 'text-green-500'
                          : etat[val._id] === 'Dysfonctionnement'
                          ? 'text-black-500'
                          : 'text-blue-700'
                      }`}
                    >
                      {etat[val._id] || 'Arrêté'}
                    </td>{' '}
                    <td className='shadow-sm px-4 py-6'>
                      <div className='flex flex-row justify-between gap-4 cursor-pointer w-4 h-4'>
                        <img
                          src={Change}
                          alt='change'
                          onClick={() => updateEtat(val._id)}
                        />
                        <img
                          src={Remove}
                          alt='remove'
                          onClick={() => {
                            deleteCompteur(val._id);
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </form>
        </PerfectScrollbar>

      </div>
      <div className='row position-absolute bottom-0 start-25 w-75'>
        <div className='col-md-12 py-3'>
          <span className='footer-text-1'>Energy Tip: </span>
          <span className='footer-text-2'>
            On all days, turning off or unplugging electrical devices when
            you're not at departments can help reduce your energy costs by
            approximately 10 percent.
          </span>
        </div>
      </div>
    </div>
  );
};

export default Compteur;
